import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import ProductForm from '../../components/products/ProductForm';
import Button from '../../components/common/Button';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useProductForm } from '../../hooks/useProductForm';
import { productService } from '../../services/product.service';
import { useToast } from '../../components/common/Toast';
import { theme } from '../../config/theme';
import { ArrowLeftIcon } from '../../components/icons/Icons';

const ProductEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [product, setProduct] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(true);

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      const response = await productService.getById(id);
      setProduct(response.data.product);
    } catch (error) {
      toast.error('Failed to load product');
      navigate('/seller/products');
    } finally {
      setFetchLoading(false);
    }
  };

  if (fetchLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!product) {
    return null;
  }

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '900px', margin: '0 auto' }}>
        {/* ✅ FIXED: Properly styled back button with icon */}
        <Button 
          variant="ghost" 
          onClick={() => navigate('/seller/products')}
          style={{ marginBottom: theme.spacing.lg }}
        >
          <ArrowLeftIcon size={18} />
          Back to Products
        </Button>

        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Edit Product
        </h1>

        {/* Render the form component only after product is loaded */}
        <ProductEditForm product={product} />
      </div>
    </MainLayout>
  );
};

// Separate component to use the product data with useProductForm hook
const ProductEditForm = ({ product }) => {
  const navigate = useNavigate();
  
  const {
    formData,
    images,
    existingImages,
    errors,
    touched,
    loading,
    handleChange,
    handleBlur,
    handleImageAdd,
    handleImageRemove,
    handleExistingImageRemove,
    handleTagAdd,
    handleTagRemove,
    handleSubmit,
  } = useProductForm(product, true);

  return (
    <ProductForm
      formData={formData}
      images={images}
      existingImages={existingImages}
      errors={errors}
      touched={touched}
      loading={loading}
      isEdit
      onChange={handleChange}
      onBlur={handleBlur}
      onImageAdd={handleImageAdd}
      onImageRemove={handleImageRemove}
      onExistingImageRemove={handleExistingImageRemove}
      onTagAdd={handleTagAdd}
      onTagRemove={handleTagRemove}
      onSubmit={handleSubmit}
      onCancel={() => navigate('/seller/products')}
    />
  );
};

export default ProductEdit;